/**
 * GLSL code based on and intended to replace the three.js "normal_fragment_maps" shader chunk.
 * We generate the basis TBN matrix (tangent-bitangent-normal) in case SUPPORT_HEIGHT_LAYERS is enabled,
 * and always do it based on vUv, which is the only uv varying we support.
 */
export const normalFragmentBeginChunk = `
float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;

#ifdef FLAT_SHADED

  vec3 fdx = dFdx( vViewPosition );
  vec3 fdy = dFdy( vViewPosition );
  vec3 normal = normalize( cross( fdx, fdy ) );

#else

  vec3 normal = normalize( vNormal );

  #ifdef DOUBLE_SIDED

    normal *= faceDirection;

  #endif

#endif

#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) || defined ( SUPPORT_HEIGHT_LAYERS )

  #ifdef USE_TANGENT

    mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );

  #else

    mat3 tbn = getTangentFrame( - vViewPosition, normal, vUv );

  #endif

  #if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )

    tbn[0] *= faceDirection;
    tbn[1] *= faceDirection;

  #endif

#endif

#ifdef USE_CLEARCOAT_NORMALMAP

    mat3 tbn2 = tbn;

#endif

// non perturbed normal for clearcoat among others

vec3 nonPerturbedNormal = normal;

`;
